import { createSelector } from "reselect";
import { initialState } from "./reducer";

const selectAssignBlocksSubmittedCasesDomain = state =>
  state.assignBlocksSubmittedCases || initialState;

const makeSelectAssignBlocksSubmittedCases = () =>
  createSelector(
    selectAssignBlocksSubmittedCasesDomain,
    substate => substate
  );

  const selectForms = () =>
  createSelector(
    selectAssignBlocksSubmittedCasesDomain,
    substate => { return substate.formData2 }
  );

export default makeSelectAssignBlocksSubmittedCases;
export { selectAssignBlocksSubmittedCasesDomain,selectForms };
